import { useState } from "react";
import { useNotificationCenter } from "NotificationCenter";

import dataProvider, {
  UPLOAD_FILE,
  UPLOAD_FILE_S3,
  CREATE,
  BULK_REPORT_UPLOADER,
} from "providers/dataProvider";

const useBulkUploader = function () {
  const [isUploading, setIsUploading] = useState(false);
  const notificationCenter = useNotificationCenter();

  const upload = async ({ dropZoneFiles, batchTypeCode }) => {
    setIsUploading(true);

    let fileNames = [];
    let files = [];

    dropZoneFiles.forEach((file, index) => {
      fileNames.push(file.name);
      files.push(file);
    });

    try {
      const lisInitResponse = await dataProvider(
        UPLOAD_FILE,
        `bulk_report_uploader/init`,
        {
          data: {
            fileNames: fileNames,
            batchTypeCode: batchTypeCode,
          },
        }
      );

      const lisBulkResponse = await dataProvider(
        BULK_REPORT_UPLOADER,
        `bulk_report_uploader/${lisInitResponse.data[0].id}/files`,
        {
          pagination: {
            perPage: 100,
          },
        }
      );

      for (const [
        index,
        lisUploadResponseItem,
      ] of lisBulkResponse.data.entries()) {
        await uploadFile({
          lisInitResponse: lisInitResponse,
          lisBulkResponse: lisBulkResponse,
          lisUploadResponseItem: lisUploadResponseItem,
          batchTypeCode: batchTypeCode,
          files: files,
          index: index,
        });
      }
      setIsUploading(false);
    } catch (e) {
      notificationCenter.show(e.message, "error");
      setIsUploading(false);
    }
  };

  const uploadFile = async ({
    lisInitResponse,
    lisBulkResponse,
    lisUploadResponseItem,
    batchTypeCode,
    files,
    index,
  }) => {
    let uploadUrl = "";

    try {
      uploadUrl = JSON.parse(lisUploadResponseItem.uploadUrl);
    } catch (e) {
      console.error(e.message);
      console.error(lisUploadResponseItem);
      notificationCenter.show(e.message, "error");
      setIsUploading(false);
    }
    const s3Request = { ...uploadUrl.fields };

    const s3Response = await dataProvider(UPLOAD_FILE_S3, uploadUrl.url, {
      data: {
        ...s3Request,
        downloadFile: files[index],
      },
    });

    if (s3Response.status !== 204) {
      notificationCenter.show("S3 error", "error");
      return false;
    }

    const lisConfirmUploadResponse = await dataProvider(
      CREATE,
      `bulk_report_uploader/${lisInitResponse.data[0].id}/finish/${lisUploadResponseItem.id}`,
      {
        data: {
          batchTypeCode: batchTypeCode,
        },
      }
    );

    if (lisBulkResponse.data.length - 1 === index) {
      notificationCenter.show(lisConfirmUploadResponse.message, "info");
    }
  };

  return {
    upload,
    isUploading,
  };
};

export default useBulkUploader;
